var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('data-table');
import { breakpoints, theme } from '@shapeable/theme';
export var DataTableDefaultProps = {
  values: [],
  cellSpacing: 0
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    color: ", ";\n    width: 100%;\n  "], ["\n    font-size: ", ";\n    color: ", ";\n    width: 100%;\n  "])), theme.FONT_SIZE(15), theme.COLOR('text')),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 33.3333%;\n\n    ", "\n  "], ["\n    width: 33.3333%;\n\n    ", "\n  "])), function (props) {
    return props.isFullScreen && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      width: 100%;\n    "], ["\n      width: 100%;\n    "])));
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: block;\n    box-sizing: border-box;\n    padding-right: ", ";\n  "], ["\n    display: block;\n    box-sizing: border-box;\n    padding-right: ", ";\n  "])), theme.UNIT(4))
});
var RowStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    background-position: bottom left;\n    display: flex;\n    justify-content: space-between;\n\n    &:last-child {\n      background: none;\n    }\n  "], ["\n    ", ";\n    background-position: bottom left;\n    display: flex;\n    justify-content: space-between;\n\n    &:last-child {\n      background: none;\n    }\n  "])), theme.DOT_BG('h', 'line-mid', 2, 4))
});
var HeaderCellStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    text-align: left;\n    font-weight: 500;\n    color: ", ";\n    padding: ", " 0;\n    display: block;\n    white-space: nowrap;\n  "], ["\n    text-align: left;\n    font-weight: 500;\n    color: ", ";\n    padding: ", " 0;\n    display: block;\n    white-space: nowrap;\n  "])), theme.COLOR('strong'), theme.UNIT(3))
});
var CellStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    color: ", ";\n    padding: ", " 0;\n    text-align: right;\n    display: block;\n\n  "], ["\n    color: ", ";\n    padding: ", " 0;\n    text-align: right;\n    display: block;\n\n  "])), theme.COLOR('strong'), theme.UNIT(3))
});
var HeadStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var HeadRowStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-weight: 400;\n  "], ["\n    font-weight: 400;\n  "])))
});
var TitleCellStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: block;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    text-transform: uppercase;\n    font-size: ", ";\n    font-weight: 400;\n    margin-left: -1px;\n    text-align: left;\n    padding: ", " 0 ", ";\n    border-bottom: 1px solid ", ";\n  "], ["\n    display: block;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    text-transform: uppercase;\n    font-size: ", ";\n    font-weight: 400;\n    margin-left: -1px;\n    text-align: left;\n    padding: ", " 0 ", ";\n    border-bottom: 1px solid ", ";\n  "])), theme.FONT_SIZE(13), theme.UNIT(3), theme.UNIT(2), theme.COLOR('line-mid'))
});
// -------- Components -------->
var My = {
  Container: styled.table(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Head: styled.thead.attrs(cls.attr('head'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), HeadStyles),
  HeadRow: styled.tr.attrs(cls.attr('head-row'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), HeadRowStyles),
  TitleCell: styled.th.attrs(cls.attr('title-cell'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TitleCellStyles),
  Body: styled.tbody.attrs(cls.attr('body'))(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Row: styled.tr.attrs(cls.attr('row'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), RowStyles),
  HeaderCell: styled.th.attrs(cls.attr('header-cell'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), HeaderCellStyles),
  Cell: styled.td.attrs(cls.attr('cell'))(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), CellStyles)
};
export var DataTable = function (props) {
  var className = props.className,
    isFullScreen = props.isFullScreen,
    values = props.values,
    title = props.title,
    cellSpacing = props.cellSpacing;
  return React.createElement(My.Container, {
    className: cls.name(className),
    isFullScreen: isFullScreen,
    cellSpacing: cellSpacing
  }, React.createElement(My.Head, null, React.createElement(My.HeadRow, null, React.createElement(My.TitleCell, {
    dangerouslySetInnerHTML: {
      __html: title ? "".concat(title, ":") : '&nbsp;'
    }
  }))), React.createElement(My.Body, null, values.map(function (_a, i) {
    var name = _a.name,
      value = _a.value;
    return React.createElement(My.Row, {
      key: "table-".concat(i)
    }, React.createElement(My.HeaderCell, {
      dangerouslySetInnerHTML: {
        __html: name ? "".concat(name, ":") : '&nbsp;'
      }
    }), React.createElement(My.Cell, null, value));
  })));
};
DataTable.defaultProps = DataTableDefaultProps;
DataTable.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;